import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  Stack,
} from "@mui/material";

const ShareDialog = ({ open, onClose, onSubmit }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      className="dialogg"
    >
      <DialogTitle textAlign="center">
        <a className="navbar-brand" href="index.html">
          <img
            className="logo-light"
            src="assets/img/logo.svg"
            alt="logo"
            style={{ margin: "0 auto" }}
          />
        </a>

        {"Share Property"}
      </DialogTitle>
      <Button onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
        ✕
      </Button>

      <DialogContent style={{ marginTop: -25 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {/* In Progress */}
          <div
            onClick={() => onSubmit(0)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "12px 16px",
              borderRadius: 10,
              cursor: "pointer",
              border: "1px solid #a7f3d0",
              background: "#ecfdf5",
              color: "#047857",
              fontWeight: 500,
            }}
          >
          <i class="ri-facebook-circle-fill"></i>
            facebook
          </div>

          {/* Approved */}
          {/* <div
            onClick={() => onSubmit(1)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "12px 16px",
              borderRadius: 10,
              cursor: "pointer",
              border: "1px solid #a7f3d0",
              background: "#ecfdf5",
              color: "#047857",
              fontWeight: 500,
            }}
          >
            <i class="ri-instagram-line"></i>
            Instagram
          </div> */}

          {/* Deactivated */}
          <div
            onClick={() => onSubmit(2)}
            style={{
                 display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "12px 16px",
              borderRadius: 10,
              cursor: "pointer",
              border: "1px solid #a7f3d0",
              background: "#ecfdf5",
              color: "#047857",
              fontWeight: 500,
            }}
          >
           <i class="ri-twitter-x-line"></i>
            X
          </div>
          <div
            onClick={() => onSubmit(3)}
            style={{
                 display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "12px 16px",
              borderRadius: 10,
              cursor: "pointer",
              border: "1px solid #a7f3d0",
              background: "#ecfdf5",
              color: "#047857",
              fontWeight: 500,
            }}
          >
           <i class="ri-whatsapp-line"></i>
            Whatsapp
          </div>

              <div
            onClick={() => onSubmit(4)}
            style={{
                   display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "12px 16px",
              borderRadius: 10,
              cursor: "pointer",
              border: "1px solid #a7f3d0",
              background: "#ecfdf5",
              color: "#047857",
              fontWeight: 500,
            }}
          >
           <i class="ri-file-copy-line"></i>
            Copy URL
          </div>


        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ShareDialog;
